import request from 'superagent'
import types from '../types'
import Dropdown from '../../types/Dropdown'
import config from '../../../package.json'
const { api_port } = config

const { protocol, hostname } = window.location
const apiUrl = api_port==='' ? `${protocol}//${hostname}/api` : `${protocol}//${hostname}:${api_port}/api`

const getRaceRequested = () => ({
  type: types.GET_RACE_REQUESTED,
  payload: null
})

const getRaceRejected = (error: any) => ({
  type: types.GET_RACE_REJECTED,
  payload: error
})

const getRaceFulfilled = (data: Array<Dropdown>) => ({
  type: types.GET_RACE_FULFILLED,
  payload: data
})

export const getRace = (token: string) => {
  return (dispatch: any) => {
    dispatch(getRaceRequested())

    request
      .get(`${apiUrl}/races`)
      .set('Accept', 'application/json')
      .set('access-token', token)
      .then((response) => {
        dispatch(getRaceFulfilled(response.body))
      })
      .catch((error) => {
        dispatch(getRaceRejected(error))
      })
  }
}